import { connect } from 'react-redux';
import React, { useState, useEffect, Fragment } from 'react';
import { createTicket, getTicketTypes } from '@actions/individualPortal/ticket/ticketActionCreators';
import { configs } from '@constants/configs/configs';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { ALLOWED_FILE_EXT, DEFAULT_CATEGORY, DEFAULT_TYPE } from '@constants/ticketMgmt/ticketMgmt';
import GIButton from '@common-components/button/GIButton';

const StyledChooseFile = styled.label`
  background-color: rgb(239, 239, 239);
  border: 0.5px solid #000;
  cursor: pointer;
  border-radius: 2px;
  padding: 3px;
`;

const TicketCreateContainer = (props) => {

    const {
        environment: {
            impersonation,
            impersonationDetails,
            language
        },
        userRole,
        createTicket,
        getTicketTypes,
        handleCloseModal,
        anchor_1,
        boundAnchor
    } = props;    


    const [ticketCategory, setTicketCategory] = useState('');
    const [categoryList, setCategoryList] = useState<any>();
    const [subTypeList, setSubTypeList] = useState<any>();
    const [ticketSubject, setTicketSubject] = useState('');
    const [ticketDetails, setTicketDetails] = useState('');
    const [selectedSubCatagory, setSelectedSubCatagory] = useState('');
    const [secondDropDown, setSecondDropDown ] = useState([]);
    const [error, setError] = useState<any>('');
    const [isSendingTicket, setSendingTicket] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState<any>([]);
    const [isFileUploadAllowed, setIsFileUploadAllowed] = useState(false);
    const [isInvalidFileError, setShowInvalidFileError] = useState(false);
    const isEnglishSelected = language === 'en' ;
    const [isDuplicatefileError, setShowDuplicatefileError] = useState(false);
    const ticketCategoryHandleChange = (e) => {
        const selectedValue = e.target.value;
        setTicketCategory(selectedValue);
        if (selectedValue === DEFAULT_CATEGORY) {
            setSecondDropDown([]);
            setSelectedSubCatagory(DEFAULT_TYPE);
            return;
        }
        setSecondDropDown(subTypeList[selectedValue]);
        let type = subTypeList[selectedValue][0];
        setSelectedSubCatagory(Object.keys(type)[0]);
        if (selectedValue !== DEFAULT_CATEGORY) {
            let tempError = { ...error };
            delete tempError.ticketRequest;
            setError(tempError);
        }
    };
    const ticketTypeHandleChange = (e) => {
        setSelectedSubCatagory(e.target.value);
    };
    const ticketSubjectHandleChange = (e) => {
        if (e.target.value.length > 3) {
            let tempError = { ...error };
            delete tempError.ticketSubject;
            setError(tempError);
        }
        setTicketSubject(e.target.value);
    };
    const ticketDetailsHandleChange = (e) => {
        if (e.target.value.length > 3) {
            let tempError = { ...error };
            delete tempError.ticketDetails;
            setError(tempError);
        }
        setTicketDetails(e.target.value);
    };

    useEffect( () => {
        let  user_id = window.UID;
        if(impersonation){
            user_id = impersonationDetails.impersonatedUserId;
        }
        getTicketTypes(configs.endpoints.TICKET_TYPES.processReplacements({ id: user_id }))
            .then(data => {
                let categoryListResponse = data?.dtoResponse?.englishSpanishCategoryMap;
                setCategoryList({ ...categoryListResponse } );
                setSubTypeList(data?.dtoResponse?.categoryMap);
                setTicketCategory(DEFAULT_CATEGORY);
                setSelectedSubCatagory(DEFAULT_TYPE);
            });
    }, []);

    useEffect(() => {
        if (selectedSubCatagory.length > 0 && selectedSubCatagory !== DEFAULT_TYPE) {
            getTicketTypes(configs.endpoints.TICKET_MGMT_GET_FILE_UPLOAD_FLAG.processReplacements({ category: ticketCategory, type: selectedSubCatagory }))
                .then(data => {
                    setIsFileUploadAllowed(data?.isFileUploadAllowed);
                })
                .catch(e => {
                    setIsFileUploadAllowed(false);
                });
        }
    }, [selectedSubCatagory]);

    useEffect(( ) => {
        if (isSendingTicket) {

            let user_id = window.UID;
            let role = userRole;
            if(impersonation){
                user_id = impersonationDetails.impersonatedUserId;
                role = impersonationDetails.role;
            }

            let args = {};
            if (isFileUploadAllowed) {
                const fd = new FormData();
                uploadedFiles.forEach((file: any) => {
                    fd.append('myfiles', file, file.name);
                });
                fd.append('type', selectedSubCatagory);
                fd.append('category', ticketCategory);
                fd.append('role', role);
                fd.append('subject', ticketSubject);
                fd.append('details', DOMPurify.sanitize(ticketDetails, {}));
                fd.append('createdBy', user_id);
                fd.append('createdFor', user_id);
                args = fd;
            } else {
                args = {
                    type: selectedSubCatagory,
                    category: ticketCategory,
                    role: role,
                    subject: ticketSubject,
                    details: DOMPurify.sanitize(ticketDetails, {}),
                    createdBy: user_id,
                    createdFor: user_id,
                };
            }

            createTicket(configs.endpoints.POST_TICKET, args, isFileUploadAllowed)
                .then(response => {
                    if (response && response.id) {
                        let pathname = window.location.href.split('/');
                        if ( pathname[pathname.length - 1] === '' ){
                            pathname.pop();
                        }
                        if ( pathname[pathname.length - 1][pathname[pathname.length - 1].length - 1] === '#' ) {
                            pathname[pathname.length - 1] = pathname[pathname.length - 1].slice(0, -1);
                        }
                        pathname.push(response.encryptedId);
                        let newLocation = pathname.join('/');
                        // @ts-ignore
                        window.location = newLocation;
                    }
                });
        }
    }, [isSendingTicket]);


    const createTicketHandler = (e) => {
        e.preventDefault();

        let minimalLength =  /([a-zA-Z].*?){4,}/;

        if(!ticketSubject) {
            setError({ ...error, ticketSubject: 'required' });
        } else if (!minimalLength.test(ticketSubject)) {
            setError({ ...error, ticketSubject: 'minlength' });
        } else if (ticketSubject.length > 50) {
            setError({ ...error, ticketSubject: 'maxlength' });
        } else if (ticketDetails.length > 2000) {
            setError({ ...error, ticketDetails: 'maxlength' });
        } else if (!ticketDetails) {
            setError({ ...error, ticketDetails: 'required' });
        } else if (!minimalLength.test(ticketDetails)) {
            setError({  ...error, ticketDetails: 'minlength' });
        } else if (ticketCategory === DEFAULT_CATEGORY) {
            setError({  ...error, ticketRequest: 'required' });
        } else if (isFileUploadAllowed && uploadedFiles.length < 1) {
            setError({  ...error, uploadedFiles: 'required' });
        } else {
            setSendingTicket(true);
        }
    };

    const firstDropDownOption = () => {
        let dropDownOptions = Object.keys(categoryList).map(key => <option key={`ticket-category-${key}`} value={key}>{isEnglishSelected ? key : categoryList[key]}</option>);
        return dropDownOptions;
    };


    const secondDropDownOption = () => {
        return secondDropDown.map((subCate, index) => <option key={`ticket-sub-category-${Object.keys(subCate)[0]}`} value={Object.keys(subCate)[0]}>{isEnglishSelected ? Object.keys(subCate)[0] : secondDropDown[index][Object.keys(subCate)[0]]}</option>);
    };

    const onFileUploadHandler = (event) => {
        const fileExtension = event.target.files.length > 0 ? event.target.files[0].name.split('.').pop() : null;
        if (fileExtension && ALLOWED_FILE_EXT.includes(fileExtension.toLowerCase())) {
            setUploadedFiles([...uploadedFiles, event.target.files[0]]);
            setShowDuplicatefileError(false);
            setShowInvalidFileError(false);
            setError({  ...error, uploadedFiles: null });

        } else {
            setShowInvalidFileError(true);
        }
    };

    const onDeleteFileHandler = (fileName) => {
        setUploadedFiles(uploadedFiles.filter(file => file && file.name !== fileName));
    };

    const renderFormMessage = () => {
        return (
            <div className='grid-col-9 create-ticket-text-container'>
                <Form.Group controlId="ticket-subject" className='grid-col-12 create-ticket-text-input'>
                    <Form.Label className='required--true'>
                        <FormattedMessage id='modals.create_ticket.subject'/>
                    </Form.Label>
                    {error.ticketSubject ? <span className='create-ticket error--msg'>&nbsp;<FormattedMessage id={`ticket.subject.${error.ticketSubject}`}/></span>: null}
                    <Form.Control size="lg"  type="text"  value={ticketSubject} onChange={ticketSubjectHandleChange} />
                </Form.Group>

                <Form.Group controlId="ticket-description" className='grid-col-12 create-ticket-text-input'>
                    <Form.Label className='required--true'>
                        <FormattedMessage id='modals.create_ticket.description'/>
                    </Form.Label>
                    {error.ticketDetails ? <span className='create-ticket error--msg'>&nbsp;<FormattedMessage id={`ticket.description.${error.ticketDetails}`}/></span>: null}
                    <Form.Control size="lg"  as="textarea" value={ticketDetails} onChange={ticketDetailsHandleChange} />
                </Form.Group>

                {
                    isFileUploadAllowed &&
                    <Form.Group controlId="ticket-description" className='grid-col-12 create-ticket-text-input'>
                        <Form.Label className='required--true'>
                            <FormattedMessage id='modals.create_ticket.file'/>
                        </Form.Label>
                        {error.uploadedFiles ? <span className='create-ticket error--msg'>&nbsp;<FormattedMessage id={`ticket.file.${error.uploadedFiles}`}/></span>: null}
                        <div style={{ display: 'flex', flexDirection: 'column', paddingTop: '1%' }}>
                            {
                                uploadedFiles && uploadedFiles.length > 0 &&
                                uploadedFiles?.map((file, idx) => {
                                    if (file) {
                                        return (
                                            <div key={idx} style={{ display: 'flex', columnGap: '5%' }}>
                                                <div>{file.name}</div>
                                                <i className='error-msg' onClick={(e) => onDeleteFileHandler(file.name)}><FontAwesomeIcon icon="times"/></i>
                                            </div>
                                        );
                                    }
                                    return null;
                                })
                            }
                            {
                                isInvalidFileError &&
                                <div className='create-ticket error--msg'><FormattedMessage id='ticket.invalid.file.type' /></div>
                            }
                            {
                                isDuplicatefileError &&
                                <div className='create-ticket error--msg'><FormattedMessage id='ticket.invalid.file.type' /></div>
                            }
                            <div style={{ paddingTop: '3%'}}>
                                <input type="file" name="file" id="uploadFileId" accept="image/*,.pdf,.doc, .docx, .xls, .xlsx" onChange={(event) => { onFileUploadHandler(event); }} onClick={(event) => (event.target as HTMLInputElement).value = ''} style={{ display: 'none' }} multiple/>
                                <StyledChooseFile htmlFor="uploadFileId"><FormattedMessage id='button.choose_files' /></StyledChooseFile>
                            </div>
                        </div>
                    </Form.Group>
                }
            </div>
        );
    };

    const RequestTypeSubType = () => {
        return (
            <div className='grid-col-3 create-ticket-dropdown-container'>
                <Form.Group controlId="ticket-Type" className='create-ticket-dropdown'>
                    <Form.Label className='required--true'>
                        <FormattedMessage id='modals.create_ticket.category' />
                    </Form.Label>
                    {error.ticketRequest ? <div className='create-ticket error--msg'><FormattedMessage id={`ticket.request.${error.ticketRequest}`}/></div>: null}
                    <Form.Control
                        size='lg'
                        as='select'
                        value={ticketCategory}
                        onChange={(e) => ticketCategoryHandleChange(e)}
                        className='gi-forms'>
                        <FormattedMessage id='modals.category.default.select'>
                            {(message) => <option value={DEFAULT_CATEGORY}>{message}</option>}
                        </FormattedMessage>
                        { categoryList ? firstDropDownOption() : null }
                    </Form.Control>
                </Form.Group>

                <Form.Group controlId="ticket-subcategory" className='create-ticket-dropdown'>
                    <Form.Label className='required--true'>
                        <FormattedMessage id='modals.create_ticket.type'/>
                    </Form.Label>
                    {error.ticketRequest ? <div className='create-ticket error--msg'><FormattedMessage id={`ticket.sub_type.${error.ticketRequest}`}/></div>: null}
                    <Form.Control
                        size='lg'
                        as='select'
                        value={selectedSubCatagory}
                        onChange={(e) => ticketTypeHandleChange(e)}
                        className='gi-forms'>
                        {ticketCategory === DEFAULT_CATEGORY ? 
                            <FormattedMessage id='modals.type.default.select'>
                                {(message) => <option value={DEFAULT_TYPE}>{message}</option>}
                            </FormattedMessage>
                            : null}
                        {secondDropDown ?  secondDropDownOption() : null}
                    </Form.Control>

                </Form.Group>
            </div>
        );
    };

    if (isSendingTicket) {
        return (
            <div>
                <p className='text-center ticket-wait-text'><FormattedMessage id='ticket.please_wait' /></p>
            </div>
        );
    }

    return (
        <Fragment>
            {
                (userRole === ALL_USER_ROLES.BROKER && !impersonation) &&
                <div className='create-ticket-broker-message'>
                    <b><FormattedMessage id='modals.create_ticket.note'/></b><FormattedMessage id='modals.create_ticket.note.message'/> <a href='/book-of-business/agent'><FormattedMessage id='modals.create_ticket.note.link'/></a><FormattedMessage id='modals.create_ticket.note.period'/>
                </div>
            }
            <Form className='grid-container-fluid'>
                <RequestTypeSubType />
                {renderFormMessage()}
                <div className='pull-right' style={{ paddingTop: '1%', paddingBottom: '1.5%' }}>
                    <GIButton id='create_ticket_cancel_btn' labelId='button.cancel' variant='secondary' onClickHandler={handleCloseModal} />
                    <GIButton id='create_ticket_submit_btn' labelId='button.submit' onClickHandler={createTicketHandler} inputRef={boundAnchor( anchor_1 )} />
                </div>
            </Form>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    userRole: state.common.environment.user.role,
    environment: state.common.environment,
});

export default connect(mapStateToProps, { createTicket, getTicketTypes })(TicketCreateContainer);